<mat-card-content>

  <h1 class="titulo-simpli">{{title}}</h1>
  <div class="subtitulo-simpli"></div>

  <div class="mt20" id="container-inversion"></div>

</mat-card-content>